import tableAppFailedTransactions from './tableAppFailedTransactions';

export default {
  tabName: 'Failed transactions',
  title: '',
  attributeName: 'appFailedTransactionPlay',
  getURL: 'appId/appFailedTransactionPlay',
  createURL: '',
  removeURL: 'appId/appTransactionPlay',
  sessionParams: ['appId'],
  isTable: true,
  noArea: true,
  tableConfig: tableAppFailedTransactions,
  href: '/test',
  eventKey: 'failed',
};
